import LayoutField from '@rjsf/core';

export const fields = {
  layout: LayoutField,
};

export const fileUploadFormSchema = {
  type: 'object',
  required: ['evidenceFiles'],
  properties: {
    evidenceFiles: {
      type: 'array',
      title: 'Attach Supporting Documents',
      items: {
        type: 'string',
      },
    },
  },
};

export const fileUploadUISchema = {
  evidenceFiles: {
    'ui:options': {
      orderable: false,
      removable: true,
    },
    items: {
      'ui:field': 'attachmentField',
    },
  },
};
